import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import Picked from './Picked';
import Available from './Available';

const styles = theme => ({
    root: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing.unit * 3,
        maxWidth: 800,
        marginLeft: 'auto',
        marginRight: 'auto'
    })
});

class Pick extends Component {
    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <Link to={`/`}>
                    <Button>&larr; Back</Button>
                </Link>

                <Picked />

                <Available />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {};
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Pick)
);



// WEBPACK FOOTER //
// ./src/components/song/Pick.js